import tokenHttpClient from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";

export const getVendorFcService = async (baseURL, requestBody) => {
  try {
    const getVendorFcRequestObj = {
      vendorCode: requestBody?.vendorCode,
    };
    const getVendorFcResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.getVendorFc}`,
      JSON.stringify(getVendorFcRequestObj)
    );
    if (getVendorFcResponse?.status === 200 && getVendorFcResponse.data) {
      return getVendorFcResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const toggleVendorFcMappingService = async (baseURL, requestBody) => {
  try {
    const toggleVendorFcMappingRequestObj = {
      vendorCode: requestBody?.vendorCode,
      fcCode: requestBody?.fcCode,
    };
    const toggleVendorFcMappingResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.toggleVendorFcMapping}`,
      JSON.stringify(toggleVendorFcMappingRequestObj)
    );
    if (
      toggleVendorFcMappingResponse?.status === 200 &&
      toggleVendorFcMappingResponse.data
    ) {
      return toggleVendorFcMappingResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const addVendorFcMappingService = async (baseURL, requestBody) => {
  try {
    const addVendorFcMappingRequestObj = {
      vendorCode: requestBody?.vendorCode,
      fcCode: requestBody?.fcCode,
    };
    const addVendorFcMappingResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.addVendorFcMapping}`,
      JSON.stringify(addVendorFcMappingRequestObj)
    );
    if (
      addVendorFcMappingResponse?.status === 200 &&
      addVendorFcMappingResponse.data
    ) {
      return addVendorFcMappingResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const getVendorDetailsService = async (baseURL, requestBody) => {
  try {
    const getVendorDetailsRequestObj = {
      vendorCode: requestBody?.vendorCode,
      email: requestBody?.emailId,
    };

    const getVendorDetailsResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.getVendorDetails}`,
      JSON.stringify(getVendorDetailsRequestObj)
    );
    if (
      getVendorDetailsResponse?.status === 200 &&
      getVendorDetailsResponse.data
    ) {
      return getVendorDetailsResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const editVendorDetailsService = async (baseURL, requestBody) => {
  try {
    const editVendorDetailsRequestObj = {
      vendorUserParam: {
        vendorCode: requestBody?.vendorCode,

        userName: requestBody?.userName,
        vendorName: requestBody?.vendorName,
        firstName: requestBody?.firstName,
        lastName: requestBody?.lastName,
        email: requestBody?.email,
        mobile: requestBody?.mobile,
      },
    };

    const editVendorDetailsResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.editVendor}`,
      JSON.stringify(editVendorDetailsRequestObj)
    );
    if (
      editVendorDetailsResponse?.status === 200 &&
      editVendorDetailsResponse.data
    ) {
      return editVendorDetailsResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const getVendorFcMasterListService = async (baseURL, requestBody) => {
  try {
    const getVendorFcMasterRequestObj = {
      vendorCode: requestBody?.vendorCode,
    };

    const getVendorFcMasterResponse = await post(
      tokenHttpClient,
      `${baseURL}${API_URL.getVendorFcMaster}`,
      JSON.stringify(getVendorFcMasterRequestObj)
    );
    if (
      getVendorFcMasterResponse?.status === 200 &&
      getVendorFcMasterResponse.data
    ) {
      return getVendorFcMasterResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
